<div class="flex flex-column w-full h-full p-0 md:p-2 overflow-y-auto overflow-x-hidden">
  <div class="flex flex-column gap-5">
    
    <!-- Hero Section Compacto e Premium -->
    <div class="hero-section p-4 flex align-items-center gap-4 shadow-2">
      <div class="flex align-items-center justify-content-center bg-white border-circle w-4rem h-4rem flex-shrink-0 shadow-1">
        <i class="pi pi-ticket text-primary text-3xl"></i>
      </div>
      <div class="flex flex-column gap-1 z-1">
        <h1 class="text-2xl font-bold m-0 text-white">Seu Ingresso Aqui</h1>
        <p class="text-white-alpha-90 text-sm m-0 line-height-3 max-w-30rem">
          Conectando pessoas a experiências inesquecíveis. A solução mais simples para seus eventos.
        </p>
      </div>
    </div>

    <!-- Grid de História e Missão -->
    <div class="grid">
      <div class="col-12">
        <div class="surface-card p-4 h-full border-round shadow-1">
          <h2 class="flex align-items-center gap-2 text-800 text-lg font-bold mb-3">
            <i class="pi pi-history text-primary"></i>
            Nossa Trajetória
          </h2>
          <div class="text-600 text-sm line-height-3 m-0 text-justify flex flex-column gap-2">
            <p class="m-0">
              A <strong>Seu Ingresso Aqui</strong> nasceu da paixão por conectar pessoas a momentos únicos. Fundada com o propósito audacioso de transformar o mercado de entretenimento no Brasil, identificamos a necessidade de uma plataforma que fosse além da venda de ingressos: precisávamos de uma solução que oferecesse <strong>segurança robusta</strong>, <strong>tecnologia de ponta</strong> e uma <strong>experiência fluida</strong> para todos.
            </p>
            <p class="m-0">
              Ao longo dos anos, evoluímos de uma startup promissora para uma das plataformas de gestão de eventos que mais cresce no país. Nossa tecnologia foi desenhada para atender desde pequenos workshops até grandes festivais, garantindo que cada organizador tenha as ferramentas necessárias para o sucesso e que cada participante desfrute de uma compra simples e segura.
            </p>
          </div>
        </div>
      </div>
      
      <div class="col-12 md:col-6">
        <div class="surface-card p-4 h-full border-round shadow-1">
          <h2 class="flex align-items-center gap-2 text-800 text-lg font-bold mb-3">
            <i class="pi pi-compass text-primary"></i>
            Nossa Missão
          </h2>
          <p class="text-600 text-sm line-height-3 m-0 text-justify">
            Nossa missão é democratizar o acesso à cultura e ao entretenimento através da tecnologia. Trabalhamos incansavelmente para criar um ecossistema onde a gestão de eventos seja descomplicada e transparente, permitindo que os organizadores foquem no que realmente importa: criar experiências inesquecíveis.
          </p>
        </div>
      </div>

      <div class="col-12 md:col-6">
        <div class="surface-card p-4 h-full border-round shadow-1">
          <h2 class="flex align-items-center gap-2 text-800 text-lg font-bold mb-3">
            <i class="pi pi-eye text-primary"></i>
            Visão de Futuro
          </h2>
          <p class="text-600 text-sm line-height-3 m-0 text-justify">
            Almejamos ser a referência nacional em inovação para o setor de eventos. Um futuro onde a compra de um ingresso seja sinônimo de segurança absoluta, agilidade e confiança, consolidando a Seu Ingresso Aqui como parceira indispensável para quem produz e para quem vive o entretenimento.
          </p>
        </div>
      </div>
    </div>

    <!-- Valores em Cards Menores -->
    <section>
      <h2 class="text-800 text-lg font-bold mb-3 px-1">Nossos Pilares</h2>
      <div class="grid">
        <div class="col-6 md:col-3">
          <div class="value-card surface-card p-3 border-round h-full flex flex-column align-items-center text-center gap-2">
            <i class="pi pi-shield text-primary text-2xl"></i>
            <span class="text-700 font-semibold text-sm">Segurança</span>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="value-card surface-card p-3 border-round h-full flex flex-column align-items-center text-center gap-2">
            <i class="pi pi-bolt text-primary text-2xl"></i>
            <span class="text-700 font-semibold text-sm">Inovação</span>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="value-card surface-card p-3 border-round h-full flex flex-column align-items-center text-center gap-2">
            <i class="pi pi-users text-primary text-2xl"></i>
            <span class="text-700 font-semibold text-sm">Transparência</span>
          </div>
        </div>
        <div class="col-6 md:col-3">
          <div class="value-card surface-card p-3 border-round h-full flex flex-column align-items-center text-center gap-2">
            <i class="pi pi-heart text-primary text-2xl"></i>
            <span class="text-700 font-semibold text-sm">Excelência</span>
          </div>
        </div>
      </div>
    </section>

    <!-- Rodapé de Contato Compacto -->
    <div class="surface-50 border-round p-3 flex flex-column md:flex-row align-items-center justify-content-between gap-3 text-sm">
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-whatsapp text-primary"></i>
        <span>(34) 9 9946-9600</span>
      </div>
      <div class="hidden md:block w-1px h-1rem surface-300"></div>
      <div class="flex align-items-center gap-2 text-700">
        <i class="pi pi-envelope text-primary"></i>
        <span>contato@seuingressoaqui.com</span>
      </div>
      <div class="hidden md:block w-1px h-1rem surface-300"></div>
      <div class="text-500 text-xs">
        CNPJ: 64.381.084/0001-33
      </div>
    </div>

  </div>
</div>
